import React from 'react';
import { HtmlTrans, SectionHeader, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';

const GroupInstructionNotes = () => {
  const { t } = useTranslation();

  return (
    <>
      <SectionHeader title={t('specialConsideration->>GroupCoordinatorInstruction.NoteTile')} />
      <ol>
        <li>
          <Typography variant="body1">
            {t('specialConsideration->>GroupCoordinatorInstruction.Note1Title')}
          </Typography>
          <ul>
            <li>
              <Typography variant="body1">
                {t('specialConsideration->>GroupCoordinatorInstruction.Note1Content1')}
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                {t('specialConsideration->>GroupCoordinatorInstruction.Note1Content2')}
              </Typography>
            </li>
          </ul>
        </li>
        <br />
        <li>
          <Typography variant="body1">
            {t('specialConsideration->>GroupCoordinatorInstruction.Note2Title')}
          </Typography>
        </li>
        <br />
        <li>
          <Typography variant="body1">
            {t('specialConsideration->>GroupCoordinatorInstruction.Note3Title')}
          </Typography>
        </li>
        <br />
        <li>
          <Typography variant="body1">
            {t('specialConsideration->>GroupCoordinatorInstruction.Note4Title')}
          </Typography>
        </li>
        <br />
        <li>
          <Typography variant="body1">
            {t('specialConsideration->>GroupCoordinatorInstruction.Note5Title')}
          </Typography>
          <ol type="a">
            <li>
              <Typography variant="body1">
                {t('specialConsideration->>GroupCoordinatorInstruction.Note5Content1.Title')}
              </Typography>
              <ul>
                <li>
                  <Typography variant="body1">
                    {t('specialConsideration->>GroupCoordinatorInstruction.Note5Content1.Part1')}
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                    <HtmlTrans i18nKey="specialConsideration->>GroupCoordinatorInstruction.Note5Content1.Part2" />
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                    {t('specialConsideration->>GroupCoordinatorInstruction.Note5Content1.Part3')}
                  </Typography>
                </li>
              </ul>
              <Typography variant="body1">
                <HtmlTrans i18nKey="specialConsideration->>GroupCoordinatorInstruction.Note5Content1.Part4" />
              </Typography>
              <br />
            </li>
            <li>
              <Typography variant="body1">
                {t('specialConsideration->>GroupCoordinatorInstruction.Note5Content2')}
              </Typography>
              <br />
            </li>
            <li>
              <Typography variant="body1">
                {t('specialConsideration->>GroupCoordinatorInstruction.Note5Content3')}
              </Typography>
              <br />
            </li>
            <li>
              <Typography variant="body1">
                {t('specialConsideration->>GroupCoordinatorInstruction.Note5Content4')}
              </Typography>
              <br />
            </li>
            <li>
              <Typography variant="body1">
                {t('specialConsideration->>GroupCoordinatorInstruction.Note5Content5')}
              </Typography>
              <br />
            </li>
          </ol>
        </li>
        <br />
      </ol>
    </>
  );
};

export default GroupInstructionNotes;
